export enum CBTProgramWeekSevenStep {
    ExposuresCheckInStep = 'exposures-check-in',
    TakingTheNextStep = 'taking-the-next-step',
    BehavioralExposuresStep = 'behavioral-exposures',
    ExposuresAndThoughtsStep = 'exposures-and-thoughts',
    PickingExposuresStep = 'picking-exposures',
    ExposureExample1Step = 'exposure-example-1',
    ExposureExample2Step = 'exposure-example-2',
    ExposureExampleSummaryStep = 'exposure-example-summary',
    YourExposureHierarchyStep = 'your-exposure-hierarchy',
    PickAnExposureStep = 'pick-an-exposure',
    ExposuresFlexibilityStep = 'exposures-flexibility',
}

export enum CBTProgramWeekSevenSurvey {
    ExposuresCheckIn = 'week-7-exposures-check-in',
    TakingTheNextStep = 'week-7-taking-the-next-step',
    YourExposureHierarchy = 'week-7-your-exposure-hierarchy',
    PickAnExposure1 = 'week-7-pick-an-exposure-1',
    PickAnExposure2 = 'week-7-pick-an-exposure-2',
}
